module.exports = __webpack_public_path__ + "img/save_black.b86d05ef.svg";